
import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxVisibleButtons = 4; // First/Last group size
        const middleButtons = 5; // Middle group size

        // First group (4 buttons)
        for (let i = 1; i <= Math.min(maxVisibleButtons, totalPages); i++) {
            pageNumbers.push(i);
        }

        // Add middle group if needed
        if (totalPages > maxVisibleButtons) {
            // Add first ellipsis
            if (currentPage > maxVisibleButtons + 1) {
                pageNumbers.push('...');
            }

            // Calculate middle group range
            const middleStart = Math.max(
                currentPage - Math.floor(middleButtons / 2),
                maxVisibleButtons + 1
            );
            const middleEnd = Math.min(
                middleStart + middleButtons - 1,
                totalPages - maxVisibleButtons
            );

            // Add middle group (5 buttons)
            for (let i = middleStart; i <= middleEnd; i++) {
                if (!pageNumbers.includes(i)) {
                    pageNumbers.push(i);
                }
            }

            // Add second ellipsis
            if (currentPage < totalPages - maxVisibleButtons) {
                pageNumbers.push('...');
            }

            // Last group (4 buttons)
            for (let i = Math.max(totalPages - 3, maxVisibleButtons + 1); i <= totalPages; i++) {
                if (!pageNumbers.includes(i)) {
                    pageNumbers.push(i);
                }
            }
        }

        return pageNumbers;
    };

    return (
        <div className="flex flex-wrap items-center justify-center gap-2 px-4 py-2">
            {/* Previous button */}
            <button
                onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`px-3 py-1 rounded disabled:bg-tangerine/40 text-white ${currentPage === 1
                    ? 'bg-tangerine/40 cursor-not-allowed text-gray-400'
                    : 'bg-tangerine hover:bg-gray-300'
                    }`}
            >
                Prev
            </button>

            {/* Page numbers */}
            {getPageNumbers().map((pageNumber, index) => (
                <button
                    key={index}
                    onClick={() => pageNumber !== '...' && onPageChange(pageNumber)}
                    className={`px-3 py-1 rounded ${pageNumber === currentPage
                            ? 'bg-tangerine text-white'
                            : pageNumber === '...'
                                ? 'bg-gray-100 cursor-default'
                                : 'bg-gray-200 hover:bg-gray-300'
                        }`}
                    disabled={pageNumber === '...'}
                >
                    {pageNumber}
                </button>
            ))}

            {/* Next button */}
            <button
                onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`px-3 py-1 rounded disabled:bg-tangerine/40 text-white ${currentPage === totalPages
                    ? 'bg-tangerine/40 cursor-not-allowed text-gray-400'
                    : 'bg-tangerine hover:bg-gray-300'
                    }`}
            >
                Next
            </button>
        </div>
    );
};

export default Pagination;